
import { t } from '@wangeditor/core';
import { TOPIC_SVG } from '../../constants/icon-svg'

/**
 * 生成唯一的 DOM ID
 */

class InsertTopicMenu {
  title = t('话题');
  iconSvg = TOPIC_SVG
  tag = 'button';

  getValue() {
    // 插入菜单，不需要 value
    return '';
  }

  isActive() {
    // 任何时候，都不用激活 menu
    return false;
  }

  exec(editor) {
    // const topicList = editor.getElemsByType('topic');
    // if (!topicList?.length) {
    //   insertTopic(editor, '话题');
    // }
    editor.insertText('#');
  }

  isDisabled(editor) {
    const topicList = editor.getElemsByType('topic');
    if (!topicList.length) return false;
    return true;
  }
}

export default InsertTopicMenu;
